import { render, staticRenderFns } from "./propertyWeekInspectList.vue?vue&type=template&id=2cfb24d2&"
import script from "./propertyWeekInspectList.vue?vue&type=script&lang=js&"
export * from "./propertyWeekInspectList.vue?vue&type=script&lang=js&"
import style0 from "./propertyWeekInspectList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports